const RequirementRuleReset = () =>
  import("../../components/requirements/RequirementRuleReset.vue");

const globalComponents = {
  RequirementRuleReset,
};

require("./css/requirements.css");

const routes = [
  // URL in RAFT where Vue JS component needs to match the following.
  // Path is used in B4, Alias in B3 if they are different paths.
  {
    // Note that requirement_rule_id can be the id, but the target id must be the uuid.
    // Ex: raft/requirements/general/1/reset/user/user/5b562e37-3f68-4265-8e52-345090ed69e2
    path: "/raft/requirements/:requirement_rule_bundle/:requirement_rule_id/reset/:target_type?/:target_bundle?/:target_id?",
    name: "requirement_rule_reset",
    component: RequirementRuleReset,
    props: true,
  },
];

export {
  routes as requirementRuleResetRoutes,
  globalComponents as requirementRuleResetGlobalComponents,
};
